import { render, staticRenderFns } from "./IRMap.vue?vue&type=template&id=a2ebafb4"
import script from "./IRMap.vue?vue&type=script&lang=js"
export * from "./IRMap.vue?vue&type=script&lang=js"
import style0 from "./IRMap.vue?vue&type=style&index=0&id=a2ebafb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports